import { siteInfo } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-primary-900 text-background-200 pt-16 md:pt-20 pb-8">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-display text-2xl text-white mb-4 inline-block">{siteInfo.name}</span>
            <p className="text-sm text-background-400 leading-relaxed mt-3">
              麻花影视是专业的影视内容聚合平台，汇集四虎影视、影视飓风、番茄影视、大叔影视、桃花影视等十余个特色影视频道的优质内容，为影迷提供一站式的个性化观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '热门榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '精选推荐', href: '#cards' },
                { label: '影迷热评', href: '#comments' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer"
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">特色频道</h4>
            <div className="space-y-2.5">
              {[
                { label: '四虎影视', href: '#cards' },
                { label: '影视飓风', href: '#cards' },
                { label: '番茄影视', href: '#cards' },
                { label: '桃花影视', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="block text-sm text-background-400 hover:text-white transition-colors cursor-pointer"
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">感谢各合作频道的信任与支持，更多优质合作伙伴持续加入中。</p>
          </div>
        </div>

        <div className="border-t border-primary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#hero" className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}>回到顶部</a>
            <a href="#faq" className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); handleNavClick('#faq'); }}>常见问题</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}>联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}